import { Injectable } from '@angular/core';
import { BaseClass } from '../shared/base.class';

@Injectable({
    providedIn: 'root',
})
export class MediaService extends BaseClass {
    /** Whether a microphone is available to use for calls */
    private _has_audio: boolean = true;
    /** Whether a camera is available to use for calls */
    private _has_video: boolean = true;

    constructor() {
        super();
        this.checkHardware();
    }

    public get has_audio() {
        return this._has_audio;
    }

    public get has_video() {
        return this._has_video;
    }

    /** Check available hardware for calls */
    public checkHardware() {
        return Promise.all([
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then((stream) => stream.getTracks().forEach((track) => track.stop()))
                .catch((_) => (this._has_audio = false)),
            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then((stream) => stream.getTracks().forEach((track) => track.stop()))
                .catch((_) => (this._has_video = false)),
        ]);
    }

    /** Save media
     * @param audio_source audio source
     * @param video_source video source
     */
    public saveMedia(audio_source, video_source): void {
        if (localStorage) {
            const data: any = {};
            if (audio_source) {
                data.audio_source = audio_source;
            }
            if (video_source) {
                data.video_source = video_source;
            }
            localStorage.setItem('MVC_NSW_H.sources', JSON.stringify(data));
        }
    }

    /** Retrieve default media */
    public getSavedMedia() {
        if (localStorage && localStorage.getItem('MVC_NSW_H.sources')) {
            return JSON.parse(localStorage.getItem('MVC_NSW_H.sources'));
        } else {
            return null;
        }
    }

    /** Enumerate media Devices */
    public enumerateDevices(): Promise<MediaDeviceInfo[]> {
        return navigator.mediaDevices.enumerateDevices();
    }

    /** Get user media */
    public getUserMedia(options: { audio: any; video: any }) {
        return navigator.mediaDevices.getUserMedia(options);
    }
}
